<template>
  <div ref="container">
    <b-field grouped>
      <b-field
        label="Height"
        label-position="on-border"
      >
        <b-input
          v-model="canvasHeightInput"
        ></b-input>
      </b-field>

      <b-field
        label="Mode"
        label-position="on-border"
        expanded
      >
        <b-select v-model="mode">
          <option value="pen">{{ $t('common.pen') }}</option>
          <option value="eraser">{{ $t('common.eraser') }}</option>
        </b-select>
      </b-field>

      <b-field>
        <button
          @click="undo"
          class="button"
        >{{ $t('common.undo') }}</button>
      </b-field>
      <b-field>
        <button
          @click="redo"
          class="button"
        >{{ $t('common.redo') }}</button>
      </b-field>
    </b-field>

    <b-field
      v-if="isActiveSaveButton"
      grouped group-multiline
    >
      <p class="control">
        <button
          @click="saveImage"
          class="button"
        >Save</button>
      </p>
      <p class="control">
        <button
          @click="savedImageData = ''"
          class="button"
        >Delete</button>
      </p>
    </b-field>
    <div v-if="savedImageData">
      <img :src="savedImageData">
    </div>

    <div ref="paintContainer" id="paintContainer"></div>
  </div>

</template>
<script>
import Konva from 'konva'

export default{
  name: 'DrawTest',

  props: {
    canvasHeightDefault: {
      type: Number,
      default: 400,
    },
  },

  data(){
    return {
      stage: null,
      layer: null,
      isPaint: false,
      lastLine: null,
      mode: 'pen',
      history: [],
      redoStack: [],
      canvasWidth: 0,
      canvasHeightInput: 400,
      canvasImage: '',
      strokeConfig: {
        color: 'black',
        width: {
          pen: 1,
          eraser: 50,
        },
      },
      isActiveSaveButton: false,
      savedImageData: '',
    }
  },

  computed: {
    screenWidth() {
      const minVal = 50
      if (this.checkEmpty(this.$refs.container) === true) return minVal
      if (this.checkEmpty(this.$refs.container.offsetWidth) === true) return minVal
      if (isNaN(this.$refs.container.offsetWidth) === true) return minVal
      return Number(this.$refs.container.offsetWidth)
    },

    canvasHeight() {
      const minVal = 50
      if (this.checkEmpty(this.canvasHeightInput) === true) return minVal
      if (isNaN(this.canvasHeightInput) === true) return minVal
      return Number(this.canvasHeightInput)
    },
  },

  watch: {
    canvasImage(val) {
      this.$emit('input', val)
    },

    canvasHeight(val) {
      if (this.checkEmpty(val) === true) return
      if (this.checkEmpty(this.stage) === true) return
      this.stage.height(val)
    },
  },

  mounted() {
    this.setCanvasSize()
    //window.addEventListener('resize', this.setCanvasSize)

    this.$nextTick(() => {
      this.stage = new Konva.Stage({
        container: 'paintContainer',
        width: this.canvasWidth,
        height: this.canvasHeight,
      })

      this.layer = new Konva.Layer()
      this.stage.add(this.layer)
      this.stage.on('mousedown touchstart', this.handleMouseDown)
      this.stage.on('mouseup touchend', this.handleMouseUp)
      this.stage.on('mousemove touchmove', this.handleMouseMove)
    })
  },

  methods: {
    setCanvasSize() {
      this.canvasWidth = this.screenWidth
      this.canvasHeightInput = this.canvasHeightDefault ? this.canvasHeightDefault : 400
      //this.canvasHeight = window.innerHeight - 282
    },

    handleMouseDown(e) {
      this.isPaint = true

      const pos = this.stage.getPointerPosition()
      this.lastLine = new Konva.Line({
        stroke: this.strokeConfig.color,
        strokeWidth: this.strokeConfig.width[this.mode],
        globalCompositeOperation:
          this.mode === 'pen' ? 'source-over' : 'destination-out',
        // round cap for smoother lines
        lineCap: 'round',
        lineJoin: 'round',
        // add point twice, so we have some drawings even on a simple click
        points: [pos.x, pos.y, pos.x, pos.y],
      })
      this.layer.add(this.lastLine)
    },

    handleMouseMove(e) {
      if (!this.isPaint) {
        return
      }

      e.evt.preventDefault()
      const pos = this.stage.getPointerPosition()
      const newPoints = this.lastLine.points().concat([pos.x, pos.y])
      this.lastLine.points(newPoints)
    },

    handleMouseUp() {
      this.isPaint = false
      this.history.push(this.lastLine)
      this.redoStack = []; // Clear the redo stack when a new action is performed
      this.canvasImage = this.stage.toDataURL({ pixelRatio: 3 })
    },

    undo() {
      if (this.history.length > 0) {
        this.lastLine = this.history.pop()
        this.redoStack.push(this.lastLine)
        this.lastLine.remove()
        //this.layer.draw()
        this.canvasImage = this.stage.toDataURL({ pixelRatio: 3 })
      }
    },

    redo() {
      if (this.redoStack.length > 0) {
        this.lastLine = this.redoStack.pop()
        this.history.push(this.lastLine)
        this.layer.add(this.lastLine)
        //this.layer.draw()
        this.canvasImage = this.stage.toDataURL({ pixelRatio: 3 })
      }
    },

    saveImage() {
      this.savedImageData = this.stage.toDataURL({ pixelRatio: 3 })
      const vals = {image: this.savedImageData}
      User.uploadImage(vals, this.userToken)
    },

    updateStageHeight() {
    },
  },
}
</script>
<style>
.konvajs-content {
  border: 1px solid #c9c9c9;
}
</style>
